import { PurchaseRequest } from "../models/PurchaseRequest";
import { Address } from "../models/Address";
import { Payment } from "../models/Payment";
import { Contact } from "../models/Contact";
import { Insured } from "../models/Insured";

import getLocale from "./getLocale";

import bus from "./bus.js";

export default function requestPurchase(vue) {
    const purchaseRequest = new PurchaseRequest();
    const payment= new Payment();
    if(vue.$store.state.site==="cibc") {purchaseRequest.Configuration.ClientCode="CIBC"}
    else {purchaseRequest.Configuration.ClientCode="CIBCIndividual"}
    payment.Amount = vue.$store.state.product.Total;
    payment.AccountIdentifier = document.getElementById("creditcard").value;
    payment.PayerName=document.getElementById("creditcard_name").value;
    const expiryMatch =  document.getElementById("expiration").value.match(/^([1-9]|0[1-9]|1[0-2])\/?(20[0-9]{2}|[0-9]{2})$/);
    payment.ExpiryMonth=expiryMatch[1];
    payment.ExpiryYear=expiryMatch[2];
    payment.CVV=document.getElementById("creditcard_cvv").value;
    payment.BillingContact=vue.$store.state.phone;
    payment.BillingAddress.Type="HOME";
    payment.BillingAddress.Address1=vue.$store.state.address1;
    payment.BillingAddress.Address2=vue.$store.state.address2;
    payment.BillingAddress.City=vue.$store.state.city;
    payment.BillingAddress.Province=vue.$store.state.province;
    payment.BillingAddress.PostalCode=vue.$store.state.postalcode;

    if(vue.$store.state.fulfillment==="mail"||
    vue.$store.state.fulfillment==="both"){
    payment.BillingAddress.IssueFulfillment=true;
    }
    else {
    payment.BillingAddress.IssueFulfillment=false;
    }

    payment.BillingAddress.FulfillmentLanguage = getLocale();
    purchaseRequest.Payments = [payment];

    let consentResponse;
    purchaseRequest.Consents=[{"Key":"TermsAndConditions","ConsentResponse":"ACCEPT"}];
    purchaseRequest.Consents.push({"Key":"PrivateInformation","ConsentResponse":"ACCEPT"});
    if(vue.$store.state.confirmCASL===true){consentResponse="ACCEPT";}
    else {consentResponse="DENY"}
    purchaseRequest.Consents.push({"Key":"CASLStatement","ConsentResponse":consentResponse});
    purchaseRequest.Consents.push({"Key":"SolicitEmail","ConsentResponse":"IMPLIED"});


    purchaseRequest.CurrentCoverage.Product=vue.$store.state.product.Product.ProductCode;
    if(document.getElementById("renewAutomatically").checked&&
    (vue.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||vue.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||vue.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"||vue.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day")&&
    vue.$store.state.oldestTraveller<60
    ) {
    purchaseRequest.CurrentCoverage.AutoRenewPreference=true;
    }
    else {
    purchaseRequest.CurrentCoverage.AutoRenewPreference=false;
    }
    purchaseRequest.CurrentCoverage.PurchaseDate = vue.$moment().format("YYYY-MM-DD");
    purchaseRequest.CurrentCoverage.PricingDate = vue.$moment().format("YYYY-MM-DD");
    purchaseRequest.CurrentCoverage.DepositDate = vue.$moment().format("YYYY-MM-DD");
    // Helper: strict parse MM/DD/YYYY, return formatted or empty string
    const safeFormat = (value) => {
      const m = vue.$moment(value, "MM/DD/YYYY", true);
      return m.isValid() ? m.format("YYYY-MM-DD") : "";
    };
    if(vue.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||vue.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||vue.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"||vue.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day"){
    purchaseRequest.CurrentCoverage.StartDate = safeFormat(vue.$store.state.tripStart);
    // For annual, compute EndDate only if tripStart valid
    if(purchaseRequest.CurrentCoverage.StartDate){
      purchaseRequest.CurrentCoverage.EndDate = vue.$moment(vue.$store.state.tripStart, "MM/DD/YYYY", true).add(1, "years").subtract(1,"day").format("YYYY-MM-DD");
    } else {
      purchaseRequest.CurrentCoverage.EndDate = "";
    }
    } else {
    purchaseRequest.CurrentCoverage.StartDate = safeFormat(vue.$store.state.departureDate);
    purchaseRequest.CurrentCoverage.EndDate = safeFormat(vue.$store.state.returnDate);
    }
    purchaseRequest.CurrentCoverage.ProvinceOfResidence = vue.$store.state.province;

    let rowsToCollect = vue.$store.state.numberOfTravellers;
    if (rowsToCollect === "") {
    rowsToCollect = 1;
    }
    for (let i = 1; i <= rowsToCollect; i++) {
    const traveller = new Insured;
    traveller.FirstName=vue.$store.state["traveller"+i+"_firstname"];
    traveller.LastName=vue.$store.state["traveller"+i+"_lastname"];
    // Safe DOB formatting: strict parse and empty string if invalid
    const dobMoment = vue.$moment(vue.$store.state["traveller"+i+"_dob"], "MM/DD/YYYY", true);
    traveller.DateOfBirth = dobMoment.isValid() ? dobMoment.format("YYYY-MM-DD") : "";
    // traveller.CoverageAmount= (vue.$store.state.tripCost/vue.$store.state.numberOfTravellers);
    if(vue.$store.state.tripCost===""){
        traveller.CoverageAmount= "0";
    }
    else {
        traveller.CoverageAmount= vue.$store.state.tripCost;
    }
    if(i===1) {
        traveller.IsPrimaryInsured=true;
        // Add medical questionnaire answers
        if(vue.$store.state.answers){
        traveller.MedicalSurveyAnswers=vue.$store.state.answers;
        traveller.MedicalSurveyCode="AZGACA2017"; // Change vue to be dynamic
        traveller.MedicalSurvey.SurveyScore=vue.$store.state.score.Score;
        traveller.MedicalSurvey.ScoringReference=vue.$store.state.score.ScoringReference;
        traveller.MedicalSurvey.VerificationToken=vue.$store.state.score.ValidationToken;
        }
        purchaseRequest.CurrentCoverage.Insured = [traveller];
    }
    else {
        traveller.IsPrimaryInsured=false;
        purchaseRequest.CurrentCoverage.Insured.push(traveller);
    }
    }


    if(vue.$store.state.fulfillment==="both"||vue.$store.state.fulfillment==="email") {purchaseRequest.FulfillmentPreference="EMAIL";}
    else {purchaseRequest.FulfillmentPreference="MAIL";}

    const address= new Address();
    address.Address1=vue.$store.state.address1;
    address.Address2=vue.$store.state.address2;
    address.City=vue.$store.state.city;
    address.Province=vue.$store.state.province;
    address.PostalCode=vue.$store.state.postalcode;
    if(vue.$store.state.fulfillment==="mail"||
    vue.$store.state.fulfillment==="both"){
    address.IssueFulfillment=true;
    }
    else {
    address.IssueFulfillment=false;
    }
    address.FulfillmentLanguage = getLocale();
    purchaseRequest.Addresses= [address];
    purchaseRequest.Contacts= [];

    if(vue.$store.state.email!=="") {
    const contact1 = new Contact();
    contact1.ContactType="EMAIL";
    contact1.ContactData=vue.$store.state.email;
    if(vue.$store.state.fulfillment==="email"||
        vue.$store.state.fulfillment==="both"){
        contact1.IssueFulfillment=true;
    }
    else {
        contact1.IssueFulfillment=false;
    }
    contact1.FulfillmentLanguage = getLocale();
    purchaseRequest.Contacts.push(contact1);
    }

    const contact2 = new Contact();
    contact2.ContactType="HOMEPHONE";
    contact2.ContactData=vue.$store.state.phone;
    contact2.IssueFulfillment = false;
    contact2.FulfillmentLanguage = null;
    purchaseRequest.Contacts.push(contact2);

    vue.isLoading=true;
    purchaseRequest.getPolicy(
    function callbackChangeStep(status, response) {
        if(status===200){
        if(response.Payments[0]&&response.Payments[0].PaymentCompleted===true){
            bus.$emit("updatePolicyNumber", response);
            bus.$emit("changeStep", "/PaymentInfo", "/Confirmation", false, true);
        }
        else if(response.Payments[0]&&(response.Payments[0].BankMessage==="Invalid Exp. Date"||response.Payments[0].GatewayMessage==="Invalid Expiry Date")){
            const targetField=document.getElementById("expiration");
            targetField.classList.remove("is-valid");
            targetField.classList.add("is-invalid");
            targetField.setAttribute("aria-invalid","true");
            bus.$emit("setError", targetField, "invalid_expiration");
        }
        else if(response.Payments[0]&&response.Payments[0].GatewayMessage==="Invalid Credit Card Number"){
            const targetField=document.getElementById("creditcard");
            targetField.classList.remove("is-valid");
            targetField.classList.add("is-invalid");
            targetField.setAttribute("aria-invalid","true");
            bus.$emit("setError", targetField, "invalid_creditcard");
        }
        else {
            bus.$emit("APIError","RWEC0012");
        }
        }
        else {
        bus.$emit("APIError","RWEC0011");
        }
        bus.$emit("hideLoading");
    });
}